import { DeveloperProductEvents } from "./pages/developers/DeveloperProductEvents";
import EstimateBrowseEvents from "./pages/estimates/EstimateBrowseEvents";
import InfringementControlBrowseEvents from "./pages/infringementControls/InfringementControlBrowseEvents";
import CommercialBrowseEvents from './pages/labs/CommercialBrowseEvents'
import { PsmEquipmentEvents } from "./pages/psm_equipments/PsmEquipmentsActions";
import { PsmRegistrationProductEvents } from "./pages/psm_status_logs/PsmRegistrationProductEvents";
import SaleBrowseEvents from "./pages/sales/SaleBrowseEvents";

export const CustomExtensions = {
    EstimateBrowseEvents,
    DeveloperProductEvents,
    PsmRegistrationProductEvents,
    PsmEquipmentEvents,
    CommercialBrowseEvents,
    SaleBrowseEvents,
    InfringementControlBrowseEvents
};
